import { render, staticRenderFns } from "./IndemnityModal.vue?vue&type=template&id=7118d0ba&scoped=true"
import script from "./IndemnityModal.vue?vue&type=script&lang=js"
export * from "./IndemnityModal.vue?vue&type=script&lang=js"
import style0 from "./IndemnityModal.vue?vue&type=style&index=0&id=7118d0ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7118d0ba",
  null
  
)

export default component.exports